
import { defineComponent } from "vue";
import AddPatient from "@/components/Add-Patient.vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "add-panient",
  components: {
    AddPatient,
  },
});
